import { Component, Injectable, Input, OnChanges, OnDestroy } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { AlertService } from '../../../../../app/utils/alert.service';
import { BindComponentService } from "../../../../../app/utils/bind.component.service";
import { VivoSyncService } from '../../../../services/vivo.sync.service';
import { LoadingComponent } from "../../../../../app/home/paraEmpresas/modalLoading/content.component";
import { DataPackGroup } from '../../../../models/dataPackGroup.model';

import * as _ from "lodash";
import * as moment from 'moment';

/**
 * @version $Id$
 */
@Component({
  selector: 'vivoSyncReport',
  templateUrl: './content.template.html'
})
@Injectable()
export class VivoSyncReportComponent{

  private static readonly GROUPS_FETCH_SIZE: number = 20;

  private groupsFetchSize: number = VivoSyncReportComponent.GROUPS_FETCH_SIZE;
  private page: number;
  private pageGroup: number;
  private totalGroups: number;
  private displayShowMoreGroupsButton: boolean = false;
  private groups: Array<DataPackGroup> = new Array<DataPackGroup>();
  private groupSortingCriteria: string;
  private groupSortingAsc: boolean = true;
  private groupLoaderInfo : String;

  @Input() reportTypeName: any;
  @Input() consumptionType: any;
  @Input() detailType: any;

  constructor(private bindComponent: BindComponentService,
    private modalService: NgbModal,
    private vivoSyncService: VivoSyncService,
    private alertService: AlertService) {
  }

  ngOnInit() {
    this.loadViewVivoSync();
  }


  private loadViewVivoSync() {
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.vivoSyncService.loadViewVivoSync(1, VivoSyncReportComponent.GROUPS_FETCH_SIZE).subscribe(
      data => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.setGroups(data['groups'], false);
        this.totalGroups = data['totalRecords'];
        this.bindComponent.set(BindComponentService.TOTAL_GROUPS, this.totalGroups);
        if(this.totalGroups > this.groupsFetchSize) {
          this.displayShowMoreGroupsButton = true;
        }
        this.pageGroup = 1;
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
    this.vivoSyncService.getVivoSyncLoadInfo().subscribe(
      data => {
        this.groupLoaderInfo = data['vivoSyncLoadDate'];
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private setGroups(groups: Array<DataPackGroup>, append: boolean) {
    if (!append) {
      this.groups = new Array<DataPackGroup>();
      this.groups = groups;
    } else {
      Array.prototype.push.apply(this.groups, groups);
    }
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modal-content-loading',
      size: 'lg',
    });
  }

  private showMoreGroups(): void {
    this.openModalLoading();
    this.pageGroup = this.pageGroup +1;
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.vivoSyncService.loadViewVivoSync(this.pageGroup, this.groupsFetchSize).subscribe(
      data => {
        this.setGroups(data['groups'], true);
        if ((this.groupsFetchSize * this.pageGroup) >= this.totalGroups) {
          this.displayShowMoreGroupsButton = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private sortGroups(field: string) {
    this.groupSortingAsc = this.groupSortingCriteria == field ? !this.groupSortingAsc : true;
    this.groupSortingCriteria = field;
    this.groups = _.orderBy(this.groups, [this.groupSortingCriteria], [this.groupSortingAsc ? 'asc' : 'desc']);
  }

  private downloadFile(group : DataPackGroup){
    this.vivoSyncService.generateReport(group);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/reports/vivosync/content.component.ts